module.exports = __webpack_public_path__ + "static/media/FORM.be79e7b6.svg";